import { Box, Text } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import TooltipWrapper from 'modules/shift_management/components/ShiftManagement/TooltipWrapper'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useTemplateWeeks } from 'modules/shift_management/hooks/useTemplateWeeks'
import { getTemplateTitle } from 'modules/shift_management/lib/getTemplateTitle'
import type { Shift } from 'modules/shift_management/lib/types'
import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

import DailyShiftDetails from '../DailyShiftDetails'
import ShiftTime from '../ShiftDetails/ShiftTime'
import ShiftTitle from '../ShiftDetails/ShiftTitle'
import { useFormatDates } from '../ShiftDetails/utils'

export interface CompactViewProps {
  shift: Shift
  date: moment.Moment
  plannedBreaks: PlannedBreak[]
}

const CompactView = ({ shift, date, plannedBreaks }: CompactViewProps) => {
  const [templateWeeks] = useTemplateWeeks()
  // TODO: Remove getTemplateTitle once 'dev_shift_management_graphql_migration' is done
  const displayName = shift.displayName || getTemplateTitle(shift, templateWeeks)
  const [{ view }] = useSchedule()
  const formatDates = useFormatDates()
  const dates = formatDates(shift, date, false)
  const time = `${dates.startAt} - ${dates.endAt} (${shift.formattedDuration(plannedBreaks)})`
  const hasNameOrTemplateTitle = !!displayName

  return (
    <Box flexDirection="column" gap="s2" minWidth="s40">
      <TooltipWrapper
        visible={hasNameOrTemplateTitle}
        label={
          <>
            <Text.Normal size="100">{displayName}</Text.Normal>
            <Text.Normal size="100">{time}</Text.Normal>
          </>
        }
      >
        {view.isDaily ? (
          <DailyShiftDetails
            shift={shift}
            templateTitle={displayName}
            date={date}
            plannedBreaks={plannedBreaks}
          />
        ) : (
          <Box>
            {hasNameOrTemplateTitle ? (
              <ShiftTitle shift={shift} templateTitle={displayName} />
            ) : (
              <ShiftTime shift={shift} date={date} plannedBreaks={plannedBreaks} />
            )}
          </Box>
        )}
      </TooltipWrapper>
    </Box>
  )
}

export default observer(CompactView)
